import React from 'react';
const items = ['Limited seats', 'Live masterclass', 'Replay included'];
export function AnnouncementBar() {
  return <div className="w-full bg-gold" data-id="element-8" data-mp="om4x6f32t1o4">
      <p className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-6 py-2.5 text-center text-[11px] font-bold uppercase tracking-[0.18em] text-ink" data-id="element-9" data-mp="on69emvtvu7f">
        {items.map((item, i) => <React.Fragment key={item} data-id="element-10" data-mp="9wffn9aoel1o" data-mpi={i}>
            {i > 0 && <span aria-hidden="true" data-id="element-11" data-mp="9x8r2nkkxyq5">·</span>}
            <span data-id="element-12" data-mp="5tsv7tgc42ei">{item}</span>
          </React.Fragment>)}
      </p>
    </div>;
}